import { call, put, StrictEffect, takeEvery } from "redux-saga/effects";

import { DataType } from "@/jenesys-types/data/enums";

import { performDataAction } from "@/services/api";
import { toastError, toastSuccess } from "@/util/helpers";

import {
  loadSuppliers,
  LoadSuppliersAction,
  loadSuppliersFailure,
  loadSuppliersSuccess,
  updateSuppliers,
  UpdateSuppliersAction,
  updateSuppliersFailure,
  updateSuppliersSuccess
} from "./lineItemExtraction";

function* loadSuppliersSaga(
  action: LoadSuppliersAction
): Generator<StrictEffect, void, any> {
  const { clientId, offset, limit, search } = action.payload;

  try {
    const response = yield call(
      performDataAction,
      DataType.LineItemExtraction,
      "loadSuppliers",
      { clientId, offset, limit, search }
    );

    yield put(loadSuppliersSuccess(response));
  } catch (error) {
    yield put(loadSuppliersFailure(error as string));
  }
}

function* updateSuppliersSaga(
  action: UpdateSuppliersAction
): Generator<StrictEffect, void, any> {
  const { clientId, suppliers } = action.payload;

  try {
    const response = yield call(
      performDataAction,
      DataType.LineItemExtraction,
      "updateSuppliers",
      { clientId },
      {},
      suppliers
    );

    yield put(updateSuppliersSuccess(response));
    toastSuccess("Suppliers updated successfully");
  } catch (error) {
    yield put(updateSuppliersFailure(error as string));
    toastError("Update suppliers failed");
  }
}

export default function* LineItemExtractionSaga() {
  yield takeEvery(loadSuppliers.type, loadSuppliersSaga);
  yield takeEvery(updateSuppliers.type, updateSuppliersSaga);
}
